module.exports = {
  siteUrl: 'https://ester1.fi',
  sitemapPath: '/sitemap.xml',
  title: 'Ester1',
  description: 'Ester1',
  author: '@aleksituompo',
};
